import HISTORY from "./types";
export const setHistoryFilter = (payload) => {
    return {
        type:HISTORY.SET_HISTORY_FILTER,
        payload
    }
}
export const getHistoryList = (payload) => {
    return {
        type:HISTORY.GET_HISTORY_LIST,
        payload
    }
}
export const setHistoryList = (payload) => {
    return {
        type:HISTORY.SET_HISTORY_LIST,
        payload
    }
}
export const setHistorySelectedRoomId = (payload) => {
    return {
        type:HISTORY.SET_HISTORY_SELECTED_ROOM_ID,
        payload
    }
}
export const getHistorySelectedRoomActions = (payload) => {
    return {
        type:HISTORY.GET_HISTORY_SELECTED_ROOM_ACTIONS,
        payload
    }
}
export const setHistorySelectedRoomActions = (payload) => {
    return {
        type:HISTORY.SET_HISTORY_SELECTED_ROOM_ACTIONS,
        payload
    }
}


